import LocalizedStrings from "react-localization";
import localization from "../localization";

export default () => {
  let translation = new LocalizedStrings(localization);
  translation.setLanguage("en");
  return translation;
};
